import Vue from 'vue';
import Vuex from 'vuex';

import urlsAPI from '../../config/urlsAPI';
import handlerError from '../../utils/errors';
import { axiosInstance } from '../../main';

Vue.use(Vuex);

export const StockStoreModel = {
  quantity: 1,
  date: new Date().toISOString(),
  invoiceBuyNumber: '',
};

export default {
  namespaced: true,
  state: {
    stock: { ...StockStoreModel },
    stocks: [],
  },
  mutations: {
    updateOne(state, stock) {
      state.stock = stock;
    },
    updateAll(state, stocks) {
      state.stocks = stocks;
    },
    add(state, stock) {
      state.stocks.push(stock);
      state.stock = { ...StockStoreModel };
    },
    modify(state, stock) {
      state.stocks = state.stocks.map((value) => (stock.id === value.id ? stock : value));
      state.stock = { ...StockStoreModel };
    },
    delete(state, id) {
      state.stocks = state.stocks.filter((stock) => stock.id !== id);
    },
  },
  actions: {
    async getStock({ commit }, { productId, stockId }) {
      return axiosInstance
        .get(urlsAPI.productsURL + productId + urlsAPI.stocksURL + stockId)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateOne', response.data);
          }
        })
        .catch(handlerError);
    },

    async getStocks({ commit }, productId) {
      axiosInstance
        .get(urlsAPI.productsURL + productId + urlsAPI.stocksURL)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateAll', response.data);
          }
        })
        .catch(handlerError);
    },

    async create({ commit, state }, productId) {
      return axiosInstance
        .post(urlsAPI.productsURL + productId + urlsAPI.stocksURL, {
          ...state.stock,
          productId,
        })
        .then((response) => {
          if (response.data.error) {
            return handlerError(response.data.error);
          }
          commit('add', response.data);
          return response.data;
        })
        .catch(handlerError);
    },

    async update({ commit, state }, { productId, stockId }) {
      return axiosInstance
        .put(urlsAPI.productsURL + productId + urlsAPI.stocksURL + stockId, state.stock)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('modify', response.data);
          }
        })
        .catch(handlerError);
    },

    async delete({ commit }, { productId, stockId }) {
      return axiosInstance
        .delete(urlsAPI.productsURL + productId + urlsAPI.stocksURL + stockId)
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('delete', stockId);
          }
        })
        .catch(handlerError);
    },

    async searchProduct({ commit }, keyword) {
      return axiosInstance
        .get(urlsAPI.productSearchURL, {
          params: {
            keyword,
          },
        })
        .then((response) => {
          if (response.data.error) {
            handlerError(response.data.error);
          } else {
            commit('updateAll', response.data);
            return response.data;
          }
        })
        .catch(handlerError);
    },

    async exportStocks(_, { start, end }) {
      return axiosInstance
        .get(urlsAPI.exportStocksURL, {
          params: {
            start,
            end,
          },
          responseType: 'blob',
        })
        .then((response) => {
          if (response.data.error) {
            return handlerError(response.data.error);
          }
          return response;
        })
        .catch(handlerError);
    },
  },
};
